import React from 'react';

type Props = {
    className?: string;
    style?: React.CSSProperties;
};

export const Rocket = ({className, style}: Props) => {
    return (
        <svg
            width="217px"
            height="217px"
            viewBox="0 0 217 217"
            version="1.1"
            className={className}
            style={style}>
            <g id="Illustrasjoner" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Things/Rocket/01" transform="translate(-19.266963, -19.000000)">
                    <g id="-g-Group">
                        <g id="symbol" transform="translate(19.500000, 19.000000)">
                            <path
                                d="M72.8136375,179.997053 C47.5354687,205.275222 0,216.823666 0,216.823666 C0,216.823666 11.5457,169.288197 36.8266125,144.010028 C52.0654,128.771241 71.0987937,125.849147 81.0366562,135.787009 C90.9745187,145.724872 87.7945125,165.016178 72.8136375,179.997053"
                                id="Fill-1"
                                fill="#F7D857"
                            />
                            <polygon
                                id="Fill-4"
                                fill="#FFF5C8"
                                points="41.5875675 175.235824 76.581355 155.889642 60.9337487 140.242036"
                            />
                            <path
                                d="M144.263082,138.746418 C144.263082,138.746418 142.786945,158.202349 133.123457,178.039662 C123.309064,198.184274 113.365714,207.998668 113.365714,207.998668 L100.387776,166.738156 L144.263082,138.746418 Z M53.4556581,119.719061 L97.1059769,163.366636 L87.8266144,168.994067 L47.8282269,128.995679 L53.4556581,119.719061 Z M78.6891038,73.1735369 L50.70011,117.048843 L9.43685375,104.070906 C9.43685375,104.070906 19.2539913,94.1275556 39.3986038,84.3131619 C59.2331725,74.6496744 78.6891038,73.1735369 78.6891038,73.1735369 L78.6891038,73.1735369 Z"
                                id="Combined-Shape"
                                fill="#06C484"
                            />
                            <path
                                d="M99.2552531,166.912109 C118.033478,158.582084 139.806409,145.722128 159.693109,125.832684 C219.613866,65.9119281 214.997603,1.82469062 214.997603,1.82469062 C214.997603,1.82469062 151.944759,-3.82596563 90.9896094,57.1319281 C72.3952156,75.7235781 59.0112031,96.8175281 50.2860781,116.942934 L99.2552531,166.912109 Z"
                                id="Fill-12"
                                fill="#2EE69F"
                            />
                            <path
                                d="M166.399932,71.6913631 C160.525563,77.5657319 151.004751,77.5657319 145.133126,71.6913631 C139.258757,65.8169944 139.258757,56.2961819 145.133126,50.4245569 C151.004751,44.5501881 160.525563,44.5501881 166.399932,50.4245569 C172.274301,56.2961819 172.274301,65.8169944 166.399932,71.6913631"
                                id="Fill-15"
                                fill="#0063FB"
                            />
                            <path
                                d="M203.725907,60.2219394 C217.411732,26.3887581 215.998701,0.825239375 215.998701,0.825239375 C215.998701,0.825239375 190.520238,-1.00758563 156.415426,12.9114581 L203.725907,60.2219394 Z"
                                id="Fill-17"
                                fill="#06C484"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};
